import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "bonificacion",
    "bonificacion",
    "Bonificacionform",
    "/bonificaciones",
);

export default handleActions(reducers, initialState);
